import React from 'react';
import { styled, LazyImage, SvgIcon } from '@teko/ui';

const StyledProductGifts = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const Label = styled.div(({ theme }) => `
  font-size: 0.6875rem;
  color: ${theme == null ? void 0 : theme.colors.gray130};
`);
const ImageWrapper = styled.div`
  margin: 0 0.2rem;
  width: 30px;
  height: 30px;
`;
const PromotionIcon = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0 0.2rem;
  box-sizing: content-box;
`;
const ProductGifts = ({
  label,
  images = [],
  className,
  voucherCount = 0
}) => /* @__PURE__ */ React.createElement(StyledProductGifts, {
  className
}, /* @__PURE__ */ React.createElement(Label, null, label), images.map((image, index) => /* @__PURE__ */ React.createElement(ImageWrapper, {
  key: index
}, /* @__PURE__ */ React.createElement(LazyImage, {
  src: image.src,
  height: 30,
  width: 30,
  border: true,
  borderRadius: 4,
  alt: image.alt,
  contain: true
}))), voucherCount > 0 && Array.from(Array(voucherCount).keys()).map((i) => {
  return /* @__PURE__ */ React.createElement(PromotionIcon, {
    key: i
  }, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "promotion",
    size: 16,
    color: "#1435c3"
  }));
}));

export { ProductGifts };
